<template>
  <v-col cols="12">
    <Loader
      v-if="loading"
      :key="generateUniqueId()"
      :loader-state="loading"
    ></Loader>

    <v-card>
      <v-card-title>Comités entreprises</v-card-title>

      <v-card-text>
        <div class="global-actions">
          <router-link :to="{ name: 'worksCouncilCreate' }">
            <v-btn
              small
              color="primary"
              class="mt-5"
            >
              Ajouter un comité entreprise
            </v-btn>
          </router-link>
        </div>
      </v-card-text>

      <v-row class="mb-5">
        <v-col
          class="tags-search ml-5"
          cols="2"
          sm="2"
        >
          <vue-tags-input
            v-model="tag"
            :tags="tags"
            placeholder="Recherche"
            @tags-changed="newTags => {
              tags = newTags
              search()
            }"
          />
        </v-col>

        <v-col
          cols="12"
          sm="6"
        >
          <v-btn
            class="mt-1"
            small
            color="info"
            @click="search()"
          >
            <v-icon
              small
              class="mr-1"
            >
              {{ icons.mdiDatabaseSearchOutline }}
            </v-icon>
            <i class="fas fa-search"></i>
            Rechercher
          </v-btn>
          <v-btn
            small
            color="info"
            class="ml-2 mt-1"
            @click="reset()"
          >
            <v-icon
              small
              class="mr-1"
            >
              {{ icons.mdiBackupRestore }}
            </v-icon>
            Réinitialisation
          </v-btn>
        </v-col>
      </v-row>

      <div class="clear"></div>

      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-uppercase">
                Entreprise
              </th>
              <th class="text-center text-uppercase">
                Tél
              </th>
              <th class="text-center text-uppercase">
                Email
              </th>
              <th class="text-center text-uppercase">
                Moteur
              </th>
              <th class="text-center text-uppercase">
                Status
              </th>
              <th class="text-center text-uppercase">
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(worksCouncil, worksCouncilIndex) in worksCouncils"
              :key="'e' + worksCouncilIndex"
            >
              <td class="font-weight-bold">
                {{ worksCouncil.company }}
              </td>
              <td class="text-center">
                {{ worksCouncil.phone }}
              </td>
              <td class="text-center">
                {{ worksCouncil.email }}
              </td>
              <td class="text-center">
                {{ worksCouncil.engine ? worksCouncil.engine.name : '-' }}
              </td>
              <td class="text-center">
                <v-chip
                  v-if="worksCouncil.enabled"
                  color="success"
                  text-color="white"
                  small
                >
                  Activé
                </v-chip>
                <v-chip
                  v-if="!worksCouncil.enabled"
                  color="error"
                  text-color="white"
                  small
                >
                  Désactivé
                </v-chip>
              </td>
              <td class="text-center">
                <v-tooltip top>
                  <template #activator="{ on, attrs }">
                    <v-btn
                      color="warning"
                      fab
                      dark
                      x-small
                      v-bind="attrs"
                      :to="{ name: 'worksCouncilDetails', params: { worksCouncilId: worksCouncil.id }}"
                    >
                      <v-icon dark>
                        {{ icons.mdiEye }}
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>Consulter</span>
                </v-tooltip>

                <v-tooltip top>
                  <template #activator="{ on, attrs }">
                    <v-btn
                      class="ml-2"
                      color="error"
                      fab
                      dark
                      x-small
                      v-bind="attrs"
                      @click="openDeleteWorksCouncilDialog(worksCouncil)"
                    >
                      <v-icon dark>
                        {{ icons.mdiTrashCan }}
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>Supprimer</span>
                </v-tooltip>
              </td>
            </tr>
          </tbody>
          <tbody v-if="!worksCouncils.length">
            <tr>
              <td>
                <span v-if="loading === false">Aucun éléments.</span>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>

      <DeleteWorksCouncilDialog
        :key="Date.now()"
        :delete-works-council-dialog-state="deleteWorksCouncilDialogState"
        :works-council="worksCouncilToDelete"
        @closeDeleteWorksCouncilDialog="closeDeleteWorksCouncilDialog($event)"
      ></DeleteWorksCouncilDialog>
    </v-card>
  </v-col>
</template>

<script>
import { mdiPlay, mdiPen, mdiEye, mdiTrashCan, mdiBackupRestore, mdiDatabaseSearchOutline } from '@mdi/js'
import Vue from 'vue'
import DeleteWorksCouncilDialog from '@/components/Dialog/WorksCouncilDialog/DeleteWorksCouncilDialog'
import config from '../../config'
import Loader from '@/components/Common/Loader'
import VueTagsInput from '@johmun/vue-tags-input'

export default {
  components: {
    DeleteWorksCouncilDialog,
    Loader,
    VueTagsInput
  },
  data: () => ({
    nextPage: 1,
    tag: '',
    tags: [],
    worksCouncils: [],
    worksCouncilToDelete: null,
    deleteWorksCouncilDialogState: false,
    loading: false,
    icons: {
      mdiPlay,
      mdiPen,
      mdiEye,
      mdiTrashCan,
      mdiBackupRestore,
      mdiDatabaseSearchOutline
    }
  }),
  computed: {
    isHandlingWorksCouncilScroll () {
      return this.$store.getters.isHandlingWorksCouncilScroll
    }
  },
  created () {
    this.getWorksCouncils()

    window.removeEventListener('scroll', this.handleScroll)

    setTimeout(() => {
      window.addEventListener('scroll', this.handleScroll)
    }, 1000)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll () {
      const wrapperOffsetHeight = document.querySelector('.v-application--wrap').offsetHeight
      const bottomOfWindow = (document.documentElement.scrollTop + window.innerHeight) === wrapperOffsetHeight

      if (bottomOfWindow && !this.isHandlingWorksCouncilScroll) {
        this.getWorksCouncils()
      }
    },
    getWorksCouncils () {
      this.loading = true

      const params = {
        page: this.nextPage
      }

      const terms = []

      for (let i = 0; i < this.tags.length; i++) {
        terms.push(this.tags[i].text)
      }

      if (terms.length) {
        params.terms = terms.join(',')
      }

      this.$store.commit('setHandlingWorksCouncilScroll', true)

      Vue.prototype.$http
        .get(config.apiUrl + '/api/works-councils', {
          headers: {
            Authorization: 'Bearer ' + this.$store.getters.getToken
          },
          params: params
        })
        .then(response => {
          if (response.status === 200) {
            const worksCouncils = response.data

            if (worksCouncils && worksCouncils.length) {
              this.worksCouncils.push(...worksCouncils)

              this.nextPage = this.nextPage + 1
            }
          }

          this.loading = false
          this.$store.commit('setHandlingWorksCouncilScroll', false)
        })
        .catch(e => {
          const response = e.response

          if (response.status === 400 || response.status === 404) {
            const data = response.data
            this.errors = data.violations
          }

          this.valid = true
          this.loading = false
          this.$store.commit('setHandlingWorksCouncilScroll', false)
        })
    },
    search () {
      const params = {
        page: 1
      }

      const terms = []

      for (let i = 0; i < this.tags.length; i++) {
        terms.push(this.tags[i].text)
      }

      if (terms.length) {
        params.terms = terms.join(',')
      }

      Vue.prototype.$http
        .get(config.apiUrl + '/api/works-councils', {
          headers: {
            Authorization: 'Bearer ' + this.$store.getters.getToken
          },
          params: params
        })
        .then(response => {
          if (response.status === 200) {
            this.worksCouncils = response.data

            this.nextPage = 2
          }
        })
        .catch(() => {
        })
    },
    reset () {
      this.tag = ''
      this.tags = []

      this.search()
    },
    openDeleteWorksCouncilDialog (worksCouncil) {
      this.deleteWorksCouncilDialogState = true
      this.worksCouncilToDelete = worksCouncil
    },
    closeDeleteWorksCouncilDialog (deleteState) {
      if (deleteState === true) {
        this.worksCouncils = this.worksCouncils.filter(element => element.id !== this.worksCouncilToDelete.id)
      }

      this.deleteWorksCouncilDialogState = false
    }
  }
}
</script>

